import { request as RequestService } from "#/utils/request";
export type DeepByCategory = {
  category: {
    id: string;
    name: string;
    image: {
      id: string;
      mime: string;
      data: string;
    };
    sort: 0;
  };
  partnerBenefits: [
    {
      partner: {
        id: string;
        legalPerson: {
          cnpj: string;
          razaoSocial: string;
          nomeSocialFantasia?: string;
        };
        image: {
          id: string;
          mime: string;
          data: string;
        };
        type: string;
        sort: 0;
      };
      benefits:
        | [
            {
              id: string;
              name: string;
              percent: string;
              image: {
                id: string;
                mime: string;
                data: string;
              };
              howToUse: {
                title: string;
                description: [string];
              };
              description: {
                title: string;
                description: [string];
              };
              partnerDescription: {
                title: string;
                description: string;
              };
              actionButton: {
                title: string;
                telephone: {
                  ddd: string;
                  number: string;
                };
                url: string;
              };
            }
          ]
        | [];
    }
  ];
};

export type CategoryPartner = {
  partner: Partner;
  id: string;
  benefit: Benefit;
};
export type Categories =
  | {
      id: string;
      name: string;
      image: {
        id: string;
        mime: string;
        data: string;
      };
      sequence?: number;
    }
  | undefined;
export type Location = {
  uf: string;
  cep: string;
  logradouro: string;
  bairro: string;
  cidade: string;
  tipoLogradouro: string;
};

export type BenefitType = {
  benefit?: {
    id: string;
    name: string;
    percent: string;
    complement?: string;
    image: {
      id: string;
      mime: string;
      data: string;
    } | null;
    howToUse: {
      title: string;
      description?: string[];
    };
    description: {
      title: string;
      description?: string[];
    };
    partnerDescription: {
      title: string;
      description: string;
    };
    actionButton: {
      title: string;
      telephone: {
        ddd: string;
        number: string;
      };
      url: string;
    };
  };
};

export type PartnerData = {
  benefit?: {
    id: string;
    name: string;
    percent: string;
    complement?: string;
    image: {
      id: string;
      mime: string;
      data: string;
    } | null;
    howToUse: {
      title: string;
      description?: string[];
    };
    description: {
      title: string;
      description?: string[];
    };
    partnerDescription: {
      title: string;
      description: string;
    };
    actionButton: {
      title: string;
      telephone: {
        ddd: string;
        number: string;
      };
      url: string;
    };
  };
  image?: {
    id: string;
    mime: string;
    data: string;
  } | null;
  category?: {
    id?: string | null;
    name?: string;
    sequence?: number;
  };
  legalPerson: {
    cnpj: string;
    razaoSocial: string;
    nomeSocialFantasia?: string;
  };
  socialMedia?: { name: string; url: string; hasUrl?: boolean }[] | null;
  telephone?: {
    ddd: string;
    number: string;
  };
  cooperative?: {
    nomeFantasia: string;
  } | null;
  location?: {
    uf: string;
    cep: string;
    logradouro: string;
    numero?: string;
    bairro: string;
    cidade: string;
    tipoLogradouro: string;
  };
  type?: string;
  id: string;
};

export type CategoryPartnerType = {
  benefit?: {
    id: string;
    name: string;
    percent: string;
    complement?: string;
    image: {
      id: string;
      mime: string;
      data: string;
    } | null;
    howToUse: {
      title: string;
      description?: string[];
    };
    description: {
      title: string;
      description?: string[];
    };
    partnerDescription: {
      title: string;
      description: string;
    };
    actionButton: {
      title: string;
      telephone: {
        ddd: string;
        number: string;
      };
      url: string;
    };
  };
  partner?: {
    image?: {
      id: string;
      mime: string;
      data: string;
    } | null;
    category?: {
      id: string;
      name: string;
      sequence?: number;
    };
    legalPerson: {
      cnpj: string;
      razaoSocial: string;
      nomeSocialFantasia?: string;
    };
    socialMedia?: { name: string; url: string; hasUrl?: boolean }[] | null;
    telephone?: {
      ddd: string;
      number: string;
    };
    cooperative?: {
      nomeFantasia: string;
    } | null;
    location?: {
      uf: string;
      cep: string;
      logradouro: string;
      numero?: string;
      bairro: string;
      cidade: string;
      tipoLogradouro: string;
    };
    type?: string;
    id: string;
  };
};

export type Partner = PartnerData | undefined;

export type Benefit = {
  id: string;
  name: string;
  percent: string;
  image: {
    id: string;
    mime: string;
    data: string;
  };
  howToUse: {
    title: string;
    description: [string];
  };
  description: {
    title: string;
    description: [string];
  };
  partnerDescription: {
    title: string;
    description: string;
  };
  actionButton: {
    title: string;
    telephone: {
      ddd: string;
      number: string;
    };
    url: string;
  };
};
export type PartnerBenefit = {
  id: string;
  partner: {
    id: string;
    legalPerson: {
      cnpj: string;
      razaoSocial: string;
    };
    image: null;
    type: null;
  };
  benefit: {
    id: string;
    name: string;
    percent: string;
    image: null;
    howToUse: {
      title: string;
      description: [string];
    };
    description: {
      title: string;
      descripton: [string];
    };
    partnerDescription: {
      title: string;
      description: string;
    };
    actionButton: {
      title: string;
      telephone: {
        ddd: string;
        number: string;
      };
      url: string;
    };
  };
};
export type Category =
  | {
      id: string;
      name: string;
      image: {
        id: string;
        mime: string;
        data: string;
      };
      sequence?: number;
    }
  | undefined;
export type CategoryPartnerActive = {
  id: string;
  category: Category;
  partner: Partner;
  location: {
    uf: string;
    cep: string;
    logradouro: string;
    bairro: string;
    cidade: string;
    tipoLogradouro: string;
  };
  telephone: {
    ddd: string;
    number: string;
  };
  cooperative: {
    nomeFantasia: string;
  };
  uri: string;
  active: boolean;
  socialMedia: [
    {
      name: string;
      url: string;
      hasUrl?: boolean;
    }
  ];
};

export interface ResponseApi {
  content?: ContentItem[];
  totalPages?: number;
  totalElements?: number;
  number?: number;
  size?: number;
  numberOfElements?: number;
  first?: boolean;
  last?: boolean;
  hasContent?: boolean;
  empty?: boolean;
}

export interface ContentItem {
  id: string;
  category: {
    id?: string | null;
    name?: string;
    sequence?: number;
  };
  partner: {
    id: string;
    legalPerson: {
      cnpj: string;
      razaoSocial: string;
      nomeSocialFantasia?: string;
    };
    image: string | null;
    type: string;
    sequence: number;
  };
  location: {
    uf: string;
    cep: string;
    logradouro: string;
    numero: string;
    bairro: string;
    cidade: string;
    tipoLogradouro: string;
  };
  cooperative: null;
  active: boolean;
  socialMedia: null;
  status: string;
  telephone: {
    ddd: string;
    number: string;
  };
}

export type Banner = {
  id: string;
  name: string;
  url: string;
  image: {
    id: string;
    mime: string;
    data: string;
  };
  sequence: 0;
};
const PartnersShowcaseService = {
  getCategories: async () => {
    const categories = (await RequestService.get<Categories[]>(`/categories`))
      .data;
    return categories.sort((a: any, b: any) => {
      return a.name.localeCompare(b.name, undefined);
    });
  },
  getPartners: async () => {
    return (await RequestService.get<Partner[]>(`/partners`)).data;
  },
  getBenefits: async () => {
    return (await RequestService.get<Benefit[]>(`/benefits`)).data;
  },
  getBenefitsById: async ({ benefitId }: { benefitId: string | undefined }) => {
    return (await RequestService.get<Benefit>(`/benefits/${benefitId}`)).data;
  },
  getBanners: async () => {
    return (await RequestService.get<Banner[]>(`/banners/highlight`)).data;
  },
  getPartnerBenefit: async () => {
    return (await RequestService.get<PartnerBenefit[]>(`/partner-benefit`))
      .data;
  },
  getPartnerBenefitDetailed: async ({ partnerId }: { partnerId: string }) => {
    return (
      await RequestService.get<PartnerBenefit>(
        `/partner-benefit/partner/${partnerId}/detailed`
      )
    ).data;
  },
  getCategoryPartnerActive: async ({
    page = 0,
    uf = "",
    typePartner = "SISTEMICO",
    size = 10,
    city = "",
    partnerName = "",
  }: {
    page: number;
    uf?: string;
    typePartner?: "SISTEMICO" | "LOCAL";
    size?: number;
    city?: string;
    partnerName?: string;
  }) => {
    return (
      await RequestService.get<ResponseApi>(
        `/category-partner?active=true&page=${page}&size=${size}&type=${typePartner}${
          city ? `&cidade=${encodeURIComponent(city)}` : ""
        }${uf ? `&uf=${encodeURIComponent(uf)}` : ""}${
          partnerName ? `&partnerName=${encodeURIComponent(partnerName)}` : ""
        }`
      )
    ).data;
  },
  getCategoryPartnerActiveRs: async () => {
    return (
      await RequestService.get<any>(`/category-partner?active=true&uf=RS`)
    ).data;
  },
  getLocation: async (zipCode: string) => {
    return (await RequestService.get<Location>(`/location/${zipCode}`)).data;
  },
};

export default PartnersShowcaseService;
